import { createFileRoute, Outlet } from '@tanstack/react-router'
import z from 'zod'
import { CanteenConnectsWidget } from '@/widgets/canteen-connects-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
  'filter.active': z.boolean().optional(),
  'filter.cafeteriaIds': z.array(z.string()).optional(),
  'filter.schoolIds': z.array(z.string()).optional(),
  'sort.field': z.string().optional(),
  'sort.order': z.string().optional(),
})

export const Route = createFileRoute('/_auth/administration/reference-books/canteens/connects')({
  staticData: {
    meta: {
      title: 'Связи школы - столовые',
      description: '',
    },
  },
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <CanteenConnectsWidget />
      <Outlet />
    </>
  )
}
